import FetchService from "../FetchService/CustomService";
import { getErrorMessage, getKeyFromURL } from "../utils";
import { STORAGE_ITEMS } from "../constants";
import LogService from "../../services/LogService";
import { WHATSAPP_TRACKING } from "../../services/webengage/webEngageConstants";
import { StorageService } from "../StorageService";

const BaseUrl = process.env.BASE_URL;
const TrackingService = {
  async whatsAppClickTracking() {
    const waRecTrackingId = StorageService.getFromSessionStorage(
      STORAGE_ITEMS.waRecTrackingId
    );
    const trackingId =
      getKeyFromURL("trackingId") || getKeyFromURL("tracking_id");
    if (trackingId && trackingId !== waRecTrackingId) {
      StorageService.setInSessionStorage(
        STORAGE_ITEMS.waRecTrackingId,
        trackingId
      );
      let url = BaseUrl + "/logs/track-whatsapp-link-click-recruiter";
      const data = {
        trackingId: trackingId
      };
      LogService.log(WHATSAPP_TRACKING, {
        trackingId
      });
      const loaderConfig = { hasLoader: false };
      try {
        const res = await FetchService.postCall({
          url,
          body: {
            ...data
          },
          loaderConfig
        });

        return res;
      } catch (error) {
        console.log("service error", error);
        return Promise.reject(getErrorMessage(error));
      }
    }
  }
};

export default TrackingService;
